$(document).ready(function () {

    $('.js-search-input').keypress(function (event) {
        // Check if the pressed key is the return key (key code 13)
        if (event.which === 13) {
            event.preventDefault(); // Prevent the default form submission

            doSearch();
        }
    });

    $('.js-search-button').on('click', function () {
        doSearch();
    });

    function doSearch() {
        var searchQuery = $('.js-search-input').val(); // Get the value of the search input
        var searchURL = '/?s=' + encodeURIComponent(searchQuery); // Construct the search URL

        window.location.href = searchURL; // Redirect to the WordPress search results page
    }

    /**
     * Load More Search Results Button functionality.
     */
    $('.blog__buttons').on('click', '.js-load-more-search', function () {

        const searchQuery = new URLSearchParams(window.location.search).get('s') || '';

        load_posts_ajax($(this), {
            action: 'load_more_search',
            search_query: searchQuery
        }, "append");
    });

});